<template>
  <div class="pt-3">
  <v-data-table
    :headers="headers"
    :items="observaciones"
    class="transparent ui-module-fade-in-up"
    hide-default-footer
    disable-pagination
  >
    <template v-slot:[`item.tipo`]="{ item }">
      <div class="tipo-chip">
        <v-icon small class="mr-2" color="secondary">{{ item.icono }}</v-icon>
        <span class="tipo-label">{{ item.tipo }}</span>
      </div>
    </template>

    <template v-slot:[`item.contenido`]="{ item }">
      <div class="observacion-celda">
        <template v-if="!item.contenido">
          <span class="sin-contenido">Sin observaciones registradas</span>
        </template>
        <template v-else>
          <div
            class="observacion-texto"
            :class="{ expandido: expandidos[item.tipo] }"
          >
            <span v-if="expandidos[item.tipo]">{{ item.contenido }}</span>
            <span v-else>{{ preview(item.contenido) }}</span>
            <span
              v-if="!expandidos[item.tipo] && excedeLimite(item.contenido)"
              class="continua-hint"
            >... <em>haz clic en "leer más" para ver el resto</em></span>
          </div>

          <v-btn
            v-if="excedeLimite(item.contenido)"
            x-small
            text
            color="secondary"
            class="mt-1 px-0 colapsar-btn"
            @click="toggleExpandido(item.tipo)"
          >
            <v-icon x-small left>
              {{ expandidos[item.tipo] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
            {{ expandidos[item.tipo] ? 'Leer menos' : 'Leer más' }}
          </v-btn>
        </template>
      </div>
    </template>
  </v-data-table>
  </div>
</template>

<script>
const PREVIEW_WORDS = 30

export default {
  name: 'ObservacionesResultadoC3DialogComponent',
  props: {
    resultadoC3: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expandidos: {
        Generales: false,
        'Adicionales A': false,
        'Adicionales B': false,
        Médicas: false,
      },
    }
  },
  computed: {
    headers() {
      return [
        { text: 'Tipo', value: 'tipo', width: '200px', sortable: false },
        { text: 'Observación', value: 'contenido', sortable: false },
      ]
    },
    observaciones() {
      return [
        {
          tipo: 'Generales',
          icono: 'mdi-file-document-outline',
          contenido: this.resultadoC3.observacionesGenerales,
        },
        {
          tipo: 'Adicionales A',
          icono: 'mdi-alpha-a-circle-outline',
          contenido: this.resultadoC3.observacionesAdicionalesA,
        },
        {
          tipo: 'Adicionales B',
          icono: 'mdi-alpha-b-circle-outline',
          contenido: this.resultadoC3.observacionesAdicionalesB,
        },
        {
          tipo: 'Médicas',
          icono: 'mdi-medical-bag',
          contenido: this.resultadoC3.observacionesMedicas,
        },
      ]
    },
  },
  methods: {
    excedeLimite(texto) {
      if (!texto) return false
      return texto.trim().split(/\s+/).length > PREVIEW_WORDS
    },
    preview(texto) {
      if (!texto) return ''
      const palabras = texto.trim().split(/\s+/)
      if (palabras.length <= PREVIEW_WORDS) return texto
      return palabras.slice(0, PREVIEW_WORDS).join(' ')
    },
    toggleExpandido(tipo) {
      this.expandidos[tipo] = !this.expandidos[tipo]
    },
  },
}
</script>

<style scoped>
.ui-module-fade-in-up {
  animation: fadeInUp 0.3s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table__wrapper {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .v-data-table-header {
  position: relative;
}

::v-deep .v-data-table-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--v-secondary-base);
  opacity: 0.15;
  pointer-events: none;
  z-index: 0;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 2px solid var(--v-secondary-base) !important;
  padding: 16px !important;
  position: relative;
  z-index: 1;
}

::v-deep .v-data-table tbody tr {
  transition: background 0.2s ease;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.08) !important;
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.08) !important;
  padding: 16px !important;
  font-size: 0.9375rem;
  vertical-align: top;
}

/* Tipo column */
.tipo-chip {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

.tipo-label {
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
  color: #e0e0e0;
}

/* Contenido column */
.observacion-celda {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 0;
}

.observacion-texto {
  line-height: 1.7;
  word-break: break-word;
  white-space: pre-line;
  color: #e0e0e0;
  transition: all 0.25s ease;
}

.observacion-texto.expandido {
  /* cuando está expandido ocupa su espacio natural sin restricción */
}

.continua-hint {
  color: rgba(224, 224, 224, 0.55);
  font-size: 0.85rem;
}

.sin-contenido {
  color: rgba(224, 224, 224, 0.4);
  font-style: italic;
  font-size: 0.875rem;
}

.colapsar-btn {
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.4px;
  opacity: 0.85;
  transition: opacity 0.2s;
}

.colapsar-btn:hover {
  opacity: 1;
}
</style>
